import type { FC } from 'react'
import { ExportFavoritesModal } from '#features/FavoriteSets/ExportFavoritesModal'
import type { FavoriteSetId } from '#features/FavoriteSets/FavoriteSet'
import { useFavoriteSets } from '#features/FavoriteSets/useFavoriteSets'

export const ConfiguratorExportFavoritesModal: FC<{
  className?: string
  open?: boolean
  initialSelection?: FavoriteSetId[]
  onOpenChange: (open: boolean) => void
}> = (props) => {
  const { activeFavoriteSet, favoriteSets } = useFavoriteSets()

  return <ExportFavoritesModal {...props} activeFavoriteSet={activeFavoriteSet} favoriteSets={favoriteSets} />
}
